import {Injectable} from '@angular/core';
import {Constants} from '../../../common/constants/constants';
import {UrlFunctions} from '../../../common/functions/url';
import {Links} from '../../../common/constants/links';

@Injectable({
  providedIn: 'root',
})
export class IframeService {

  private INDEX_HASH_FOR_INSURER: number = 2;

  private INDEX_HASH_FOR_BROKER: number = 3;

  private BROKER: string = 'broker';

  private INTER_PENSION: string = 'inter-pension';

  /**
   * Method: Checks if the current page is an iframe page
   * @returns {boolean} - true if the current page is an iframe page, false otherwise
   */
  isIframePage(): boolean {
    return UrlFunctions.isPageByRouteUrl(Links.IFRAME_LINK_URL);
  }

  /**
   * Method: Gets the hash from the iframe URL
   * @returns The hash from the iframe URL
   */
  getIframeHash(): string {
    // Parse the URL to extract the pathname
    const urlObj = new URL(window.location.href);
    const pathNameArr = urlObj.pathname.split(Constants.SLASH);

    // Determine the index based on the pathname and select the corresponding hash
    const index = pathNameArr.includes(this.INTER_PENSION) || pathNameArr.includes(this.BROKER)
      ? this.INDEX_HASH_FOR_BROKER
      : this.INDEX_HASH_FOR_INSURER;

    // Return the hash from the specified index
    return pathNameArr[index];
  }

}
